import { useMutation } from "react-query";
import downloadCampaignCsv from "../services/downloadCampaignCSV";

function useDownloadCampaignCSV() {
  return useMutation(["download-campaign-csv"], downloadCampaignCsv);
}

export default useDownloadCampaignCSV;
